import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Country } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  constructor(private http: HttpClient) {}

  get() {
    return this.http.get<Country[]>(`${API}countries`);
  }
}
